import React, { useCallback } from 'react';
import { GenericPaymentModal } from '../GenericPaymentModal/GenericPaymentModal';
import type { TSaleCategory } from '../../types/global/helper';
import type { SandboxCoursePaymentPayload } from '../../utils/openSandboxCourseCheckout';
import { showToastMessage } from '../../utils/AppUtils';

type Props = {
    open: boolean;
    title: string;
    payload: SandboxCoursePaymentPayload;
    onClose: () => void;
    onSuccess: () => void;
    /** Defaults to sandbox_course */
    category?: TSaleCategory;
    successMessage?: string;
    linkedEventType?: string;
};

/**
 * Sandbox purchases (courses, office hours) via the regional payment rail
 * (Stripe / Paystack / Flutterwave) — same shell as tokens & tickets.
 */
export function SandboxCoursePaymentModal({
    open,
    title,
    payload,
    onClose,
    onSuccess,
    category = 'sandbox_course',
    successMessage = 'You are enrolled — start watching anytime',
}: Props) {
    const handleComplete = useCallback(() => {
        showToastMessage(successMessage, 'success');
        onSuccess();
    }, [onSuccess, successMessage]);

    return (
        <GenericPaymentModal
            open={open}
            onClose={onClose}
            title={title}
            items={payload.items}
            saleObject={payload.saleObject}
            currencyInfo={payload.currencyInfo}
            category={category}
            amountsInCents
            additionalFees={payload.additionalFees || []}
            showItemImages={Boolean(payload.items[0]?.image)}
            maxWidth="sm"
            additionalMetadata={{
                linked_event: payload.saleObject.linked_event,
                linked_event_type: payload.saleObject.linked_event_type,
                ...(payload.saleObject as { metadata?: Record<string, unknown> }).metadata,
            }}
            onPaymentComplete={() => {
                handleComplete();
            }}
            onPaystackComplete={() => {
                handleComplete();
            }}
        />
    );
}
